// import DataSoap from "@/services/DataSoap";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import { TransaksiFarmasiItem } from "@/types/obat_farmasi";

// interface ItemHasil {
//   id: string;
//   nama: string;
// }

// interface ListItemLab {
//   transId: string;
//   dateTime: string;
//   lis_sampel: string;
//   unit: {
//     kode: string;
//     nama: string;
//   };
//   item: Array<ItemHasil>;
// }

interface ListHasilRadiologi {
  no_transaksi: string;
  tgl: string;
  dr_pengirim: string;
  dr_radiologi: string;
  unit: {
    id: string;
    nama: string;
  };
  hasil: [
    {
      kode: string;
      nama: string;
      acc_number: string;
      description: string;
      reportDate: string;
      dokter: string;
      link: string;
    }
  ];
}

interface ListHasilLab {
  no_order: string;
  tgl_order: string;
  no_trans: string;
  lis_sampel: string;
  acc_by: string;
  acc_date: string;
  unit: {
    id: string;
    nama: string;
  };
  hasil: Array<{
    test_id: string;
    nama_test: string;
    jenis_hasil: string;
    hasil: string;
    satuan: string;
    nilai_normal: string;
    flag: string;
    kode_paket: string;
    reserve4: string;
  }>;
  hasil_mikro: string;
}

@Module({ store, dynamic: true, name: "hasil-penunjang" })
class HasilPenunjang extends VuexModule {
  loading = false;
  loadingRadiologi = false;
  loadingLab = false;

  listTrxObat: Array<TransaksiFarmasiItem> = [];

  // listObat: Array<ItemHasil> = [];
  // listLab: Array<ListItemLab> = [];
  // listRadiologi: Array<ItemHasil> = [];

  listHasilRadiologi: Array<ListHasilRadiologi> = [];
  listHasilLab: Array<ListHasilLab> = [];

  @Mutation SET_OBAT(listObat: Array<TransaksiFarmasiItem>) {
    this.listTrxObat = listObat;
  }

  // @Mutation SET_LAB(listLab: Array<ListItemLab>) {
  //   this.listLab = listLab;
  // }

  @Mutation SET_LAB(listLab: Array<ListHasilLab>) {
    this.listHasilLab = listLab;
  }

  // @Mutation SET_RADIOLOGI(listRadiologi: Array<ItemHasil>) {
  //   this.listRadiologi = listRadiologi;
  // }

  @Mutation SET_RADIOLOGI(listRadiologi: Array<ListHasilRadiologi>) {
    this.listHasilRadiologi = listRadiologi;
  }

  @Mutation SET_LOADING_RADIOLOGI(val: boolean) {
    this.loadingRadiologi = val;
  }

  @Mutation SET_LOADING_LAB(val: boolean) {
    this.loadingLab = val;
  }

  @Mutation RESET_ALL() {
    this.listTrxObat = [];
    this.listHasilRadiologi = [];
    this.listHasilLab = [];
  }

  @Action async getObatByRegister(reg: string | number) {
    const dt = await HasilPenunjangSvc.getObatByRegister(reg);

    const { data } = dt;

    this.SET_OBAT(data);
  }

  @Action async getLabByRegister(reg: string | number) {
    this.SET_LOADING_LAB(true);

    const dt = await HasilPenunjangSvc.getLabByRegister(reg).finally(() => {
      this.SET_LOADING_LAB(false);
    });

    const { data } = dt;

    this.SET_LAB(data);

    return data;
  }

  @Action async getRadiologiByRegister(reg: string | number) {
    this.SET_LOADING_RADIOLOGI(true);

    const dt = await HasilPenunjangSvc.getRadiologiByRegister(reg).finally(
      () => {
        this.SET_LOADING_RADIOLOGI(false);
      }
    );

    const { data } = dt;

    this.SET_RADIOLOGI(data);
  }

  @Action reset() {
    this.RESET_ALL();
  }
}

export const storeHasilPenunjang = getModule(HasilPenunjang);
